import { render, staticRenderFns } from "./depositModal.vue?vue&type=template&id=467f565a"
import script from "./depositModal.vue?vue&type=script&lang=js"
export * from "./depositModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports